import { LayoutHeader } from "@/Header";
import { createFileRoute } from "@tanstack/react-router";
import { SealManagementPanel } from "@/business/contract/SealManagementPanel";
import { ContractPinGate } from "@/business/contract/ContractPinGate";

/** 도장 관리 단독 라우트 (계약 관리 트리에서 펼쳤을 때와 동일 컴포넌트 재사용) */
export const Route = createFileRoute("/business/layout/seal-management")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <LayoutHeader title="도장 관리" hasBackBtn hasFootPrint={false} />
      <ContractPinGate ownerOnly>
        <div className="flex-1 min-h-0 flex flex-col bg-[#F5F5F5]">
          <div className="flex-1 min-h-0 overflow-y-auto px-4 pt-3">
            <SealManagementPanel />
          </div>
        </div>
      </ContractPinGate>
    </>
  );
}
